import { useMutation } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import axios from "../../../../services/department-viags/config.service";
import { BaseResponse } from "../../../chats/types";

interface MoveFolderSchema {
  key: string;
  newParentKey: string;
  newPosition: number;
}

const BASE_PATH = "/edoc";

const folderApi = {
  move: async (body: MoveFolderSchema, config?: AxiosRequestConfig) => {
    await axios.post<BaseResponse<unknown>>(`${BASE_PATH}/move-folder`, body, config);
  },
};

const useMoveFolder = () => {
  return useMutation({
    mutationFn: (body: MoveFolderSchema) => folderApi.move(body),
  });
};

export default useMoveFolder;
